require('./plugins');

const app = new Vue({
    el: '#userdb',

    created() {
        this.$set(this, 'params', window.queryString.parse(window.location.search));
        this.$set(this, 'platform', this.isMobileBrowser() ? 'mobile' : 'desktop');
        // this.$set(this, 'browser', window.browser());
        document.body.classList.add(this.platform);
        window.platform = this.platform;
        this.$set(this, 'sidebarCollapsed', document.body.classList.contains('sidebar-collapse') || this.$ls.get('sidebarCollapsed') || false);
        this.$set(this, 'perPage', Number(this.$ls.get('perPage')) || 12);
    },

    mounted() {
        this.changeMenuAppearance();
    },

    data() {
        return {
            platform:         'desktop',
            browser:          {},
            params:           [],
            showModal:        false,
            showNestedModal:  false,
            modalData:        null,
            sidebarCollapsed: false,
            perPage:          12
        };
    },

    methods: {
        isMobileBrowser() {
            let md = new window.MobileDetect(window.navigator.userAgent);
            return md.mobile();
        },

        closeModal() {
            this.$set(this, 'showModal', false);
            this.$set(this, 'modalData', null);
        },

        closeNestedModal() {
            this.$set(this, 'showNestedModal', false);
            this.$set(this, 'modalData', null);
        },

        pushMenu() {
            this.$set(this, 'sidebarCollapsed', !this.sidebarCollapsed);
            this.$ls.set('sidebarCollapsed', this.sidebarCollapsed);
        },

        changeMenuAppearance() {
            if (!this.sidebarCollapsed) {
                document.body.classList.add('sidebar-collapse');
            } else {
                document.body.classList.remove('sidebar-collapse');
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js